import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/utils'

/** "Equipe" = owner, admin, moderator and finance (David). */
const TEAM_ROLES = new Set(['owner', 'admin', 'moderator', 'finance'])

/** The server says `isTeam`; older payloads only carry `role`. */
export const teamRoleOf = (p?: { role?: string | null; isTeam?: boolean | null } | null): string | null => {
  const role = (p?.role || '').toLowerCase()
  if (p?.isTeam === false) return null
  if (TEAM_ROLES.has(role)) return role
  return p?.isTeam ? role || null : null
}

/** 2 px ring in the community primary color around a team member's avatar (no blur). */
export const TEAM_RING_CLASSES = 'ring-2 ring-primary ring-offset-1 ring-offset-white'

/** Small chip after the name with the team role, using the app's role labels. */
export const RoleChip = ({ role, className }: { role: string | null; className?: string }) => {
  const { t } = useTranslation('members')
  if (!role) return null
  return (
    <span
      data-chat-role={role}
      className={cn('inline-flex shrink-0 items-center rounded-full bg-primary-50 px-1.5 py-px text-[10px] font-semibold leading-4 text-primary-700', className)}
    >
      {t(`role.${role}`)}
    </span>
  )
}
